import { makeRequester } from "./base";

export const getIsAuthenticated = makeRequester("/api/frontend/user/me/");

export default {
  getIsAuthenticated,
};
